import React from 'react'
import { createBehavior, createResource } from '@designable/core'
import { DnFC, DroppableWidget } from '@designable/react'
import { connect, mapProps, mapReadPretty, ReactFC, useForm, useFormEffects} from '@formily/react'
import { createBaseSchema } from '../Field'
import { withContainer } from '../../common/Container'
import { AllSchemas } from '../../../../FormilyMobile/src/schemas'
// import FormilyBox from '../../../../FormilyMobile/src/components/Box/Box'

const FBox =  ({children, ...props}: any) => {
  return <div className='fromily-box' {...props} >{children}</div>
}

const FormilyBox: ReactFC<any> = withContainer(FBox)


export const Box: DnFC<any> = FormilyBox

Box.Behavior = createBehavior({
  name: 'Box',
  extends: ['Field'],
  selector: (node) => node.props['x-component'] === 'Box',
  designerProps: {
    droppable: true,
    propsSchema: createBaseSchema(AllSchemas.Box),
  },
  designerLocales: {
    'zh-CN': {
      title: '普通容器',
    }
  },
})

Box.Resource = createResource({
  icon: 'BoxSource',
  elements: [
    {
      componentName: 'Field',
      props: {
        type: 'void',
        'x-component': 'Box',
      },
    },
  ],
})
